// extracted by mini-css-extract-plugin
export default {"switch":"switch__3N_65","slider":"slider__1FYz5","round":"round__cMqXu"};
    if(module.hot) {
      // 1788784374071
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  